import * as React from "react";

function JabilIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 76 28"
    >
      <defs>
        <clipPath>
          <rect width="76" height="28" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-jabil)">
        <path
          data-name="Path 7144"
          d="M-35.36-2.86V-5.434h1.924V-3.51l1.768,1.742h4.446l1.482-1.456V-18.2h1.976V-2.6l-2.6,2.6H-32.5ZM-13.91-18.2h2.132L-5.3,0H-7.358l-1.69-4.914H-16.64L-18.33,0h-2.054ZM-9.62-6.63l-3.2-9.282h-.052L-16.042-6.63ZM-1.4-18.2H8.814l2.392,2.392v5.044L9.958-9.516l2.054,2.054v4.914L9.464,0H-1.4ZM7.982-9.984l1.3-1.3V-15.21l-1.3-1.274H.52v6.5Zm.6,8.268L10.088-3.2v-3.64L8.58-8.32H.52v6.6ZM16.822-18.2H18.8V0H16.822Zm7.566,0h1.976V-1.742H35.62V0H24.388Z"
          transform="translate(38 23)"
          fill="#3c98e8"
        />
      </g>
    </svg>
  );
}

export default JabilIcon;
